import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bad-request',
  templateUrl: './bad-request.component.html',
  styles: []
})
export class BadRequestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
